/**
 * Utility functions for markdown detection and processing
 */

/**
 * Detects if text is likely formatted as markdown
 * @param text - The text to check for markdown formatting
 * @returns boolean indicating if the text appears to contain markdown
 */
export const isMarkdown = (text: string): boolean => {
  // Check for common markdown patterns
  const markdownPatterns = [
    /[#]+\s+.+/, // Headers
    /\*\*.+\*\*/, // Bold text
    /\*.+\*/, // Italic text
    /\[.+\]\(.+\)/, // Links
    /```[\s\S]+```/, // Code blocks
    /^\s*[-*+]\s+.+/m, // Unordered lists
    /^\s*\d+\.\s+.+/m, // Ordered lists
    />\s+.+/, // Blockquotes
    /\|.+\|.+\|/, // Tables
    /!\[.+\]\(.+\)/, // Images
  ];

  // If it starts with ```markdown and ends with ```, it's definitely markdown
  if (/^```markdown[\s\S]*```$/m.test(text)) {
    return true;
  }

  return markdownPatterns.some((pattern) => pattern.test(text));
};

/**
 * Cleans markdown text by removing code block delimiters
 * @param text - The markdown text to clean
 * @returns The cleaned markdown text
 */
export const cleanMarkdown = (text: string): string => {
  return text.replace(/^```(markdown)?|```$/gm, "").trim();
};
